import { render, staticRenderFns } from "./injuries.vue?vue&type=template&id=785d3406&scoped=true"
import script from "./injuries.vue?vue&type=script&lang=js"
export * from "./injuries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785d3406",
  null
  
)

export default component.exports